import { QuestionEditstyled } from "./styles/QuestionEdit.styled";

export default function PersonalColorQuestionEdit() {
  return <QuestionEditstyled>나의 퍼스널 컬러는?</QuestionEditstyled>;
}
